<div class="container">
  <span class="name" *ngIf="isNameVisible()" [class.name--title]="isAll()">
    {{ name }}
  </span>

  <div #plantContainer class="plant-container" *ngIf="isPlantsVisible()">
    <span class="plant-container__text" *ngFor="let plant of plants">
      {{ plant }}
    </span>
  </div>
</div>
